export enum DayOfWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

/**
 * Backend uses 0=Sunday, 1=Monday, ... 6=Saturday
 * Maps backend ordinal to DayOfWeek enum
 */
const ORDINAL_TO_DAY: Record<number, DayOfWeek> = {
  0: DayOfWeek.SUNDAY,
  1: DayOfWeek.MONDAY,
  2: DayOfWeek.TUESDAY,
  3: DayOfWeek.WEDNESDAY,
  4: DayOfWeek.THURSDAY,
  5: DayOfWeek.FRIDAY,
  6: DayOfWeek.SATURDAY,
};

/**
 * Maps DayOfWeek enum to backend ordinal (0=Sunday, 1=Monday, ... 6=Saturday)
 */
const DAY_TO_ORDINAL: Record<DayOfWeek, number> = {
  [DayOfWeek.SUNDAY]: 0,
  [DayOfWeek.MONDAY]: 1,
  [DayOfWeek.TUESDAY]: 2,
  [DayOfWeek.WEDNESDAY]: 3,
  [DayOfWeek.THURSDAY]: 4,
  [DayOfWeek.FRIDAY]: 5,
  [DayOfWeek.SATURDAY]: 6,
};

export function ordinalToDayOfWeek(ordinal: number): DayOfWeek {
  return ORDINAL_TO_DAY[ordinal];
}

export function dayOfWeekToOrdinal(dayOfWeek: DayOfWeek): number {
  return DAY_TO_ORDINAL[dayOfWeek];
}
